import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceDataForm, ServiceFilters } from '../../../app/models/Service';
import { WarehouseOrderExtraServiceDataForm } from '../../../app/models/WareHouseOrderExtraService';
import useWarehouseOrderExtraService from '../../../app/services/hooks/useWareHouseOrderExtraServicesService';
import { AppContext } from '../../../contexts/AppContext';
import { ItemCategory } from '../../../app/models/ItemCategory';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import { Sector } from '../../../app/models/Sector';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import WarehouseOrderExtraServiceForm from './forms/WareHouseOrderExtraServicesForms/WareHouseOrderExtraServicesForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    quoteId: number;
    onSaved: () => void;
    onError?: () => void;
    onCancel: () => void;

}

const WarehouseExtraServiceCreate = ({
    quoteId,
    onSaved,
    onCancel,
    onError 
}: Props) => {

    const {createWarehouseOrderExtraService, storeWarehouseOrderExtraService } = useWarehouseOrderExtraService();
    const [serviceFilter, setServiceFilter] = useState<ServiceFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'asc'
    });
    const [extraServiceform, setExtraServicesForm] = useState<WarehouseOrderExtraServiceDataForm>({
        warehouse_order_id: quoteId,
        service_id: 0,
    });
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [services, setServices] = useState<ServiceDataForm[]>([]);
    const [showingServiceCreate, setShowingServiceCreate] = useState(false);
    const [sectors] = useState<Sector[]>([]);
    const [itemCategories, setItemCategories] = useState<ItemCategory[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        create();
    }, []);

    // const loadServices = () => {
    //     getServices(
    //        serviceFilter,
    //         {
    //             onSuccess: (response: ServiceResponse) => {
    //                 setServices(response.data.services);
    //             },
    //             onError: (response: ServiceResponse) => {
    //                 toast.error(response.message);
    //             }
    //         }
    //     );
    // };

    const create = () => {
            // sólo se ejecuta una vez al montar
            createWarehouseOrderExtraService(quoteId, {
            onSuccess: (response: ServiceResponse) => {
                // setSectors(response.data.sectors);
                // setExtraServicesForm(response.data.services);
                setServices(response.data.services);

                setItemCategories(response.data.item_categories);
                setUnits(response.data.units);
                setCurrencies(response.data.currencies);

                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
            });
        };

    const store = () => {
        storeWarehouseOrderExtraService(extraServiceform, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },

            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }


        });
    };



    return (
        <>
            <WarehouseOrderExtraServiceForm
                extraServiceForm={extraServiceform}
                setExtraServiceForm={setExtraServicesForm}
                currencies={currencies} // Puedes completar si corresponde
                units={units}
                services={services}
                disabled={false} 
                itemCategories={itemCategories} 
                errorFields={errorFields}
                />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} />
                </div>
            </div>

            {/* <DefaultModal
                show={showingServiceCreate}
                handleClose={() => setShowingServiceCreate(false)}
                title="Crear Servicio Adicional"
                showFooter={false}
            >
                <ServiceCreate
                    onSaved={() => {
                        // reloadTable();
                        // setShowingEdit(false);
                    }}
                    onCancel={() => setShowingServiceCreate(false)}
                    onError={() => setShowingServiceCreate(false)}
                />
            </DefaultModal> */}
        </>
    );
};

export default WarehouseExtraServiceCreate;
